import React from 'react';
import styled from 'styled-components';
import { scrollToAnchor } from 'utils';

function Aside({
  anchors,
  showTitles,
  activeAsideButtonIndex,
  setActiveAsideButtonIndex,
  setAsideButtonManuallyClicked
}) {
  return (
    <Container aria-hidden="true">
      {anchors.map((anchor) => (
        <AnchorItem
          key={anchor.id}
          tabIndex={-1}
          aria-hidden="true"
          role="button"
          smallerAnchor
          active={activeAsideButtonIndex === `${anchor.id}-section`}
          hasTitle={showTitles}
          showTitles
          onClick={() => {
            setAsideButtonManuallyClicked(true);
            setActiveAsideButtonIndex(`${anchor.id}-section`);
            scrollToAnchor(`${anchor.id}-section`);
            setTimeout(() => setAsideButtonManuallyClicked(false), 1000);
          }}
          highlightColor={anchor.highlightColor}>
          {showTitles ? (
            <p style={{ display: 'flex', flexDirection: 'row', gap: '0.3rem'}}>
              <p>{`${anchor.id}.`}</p>
              <p>{`${anchor.title}`}</p>
            </p>
          ) : (
            anchor.id
          )}
        </AnchorItem>
      ))}
    </Container>
  );
}

const Container = styled.aside`
  align-self: start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: auto;
  margin-bottom: 4.969rem;
  position: sticky;
  top: 2.563rem;
  width: 100%;
`;

const AnchorItem = styled.div`
  border: ${({ active }) => (active ? 'none' : '1px solid var(--ax-gold)')};
  border-radius: 2px;
  background-color: ${({ active, highlightColor }) => (active ? highlightColor : 'transparent')};
  cursor: pointer;
  font-size: ${({ hasTitle }) => (hasTitle ? '0.875rem' : '1.5rem')};
  font-weight: 700;
  color: ${({ active }) => (active ? 'var(--ax-white)' : '#c1beac')};
  text-decoration: none;
  transition: 150ms ease-in-out;
  height: ${({ hasTitle }) => (hasTitle ? 'auto' : '2.5rem')};
  width: ${({ hasTitle }) => (hasTitle ? '200px' : '2.5rem')};
  min-height: ${({ hasTitle }) => (hasTitle ? '3rem' : '2.5rem')};
  padding: ${({ hasTitle }) => (hasTitle ? '0.75rem' : '0')};
  display: flex;
  align-items: center;
  justify-content: ${({ hasTitle }) => (hasTitle ? 'flex-start' : 'center')};
  text-align: ${({ hasTitle }) => (hasTitle ? 'left' : 'center')};
  line-height: ${({ hasTitle }) => (hasTitle ? '1.3' : 'normal')};
  white-space: ${({ hasTitle }) => (hasTitle ? 'normal' : 'normal')};
  word-wrap: ${({ hasTitle }) => (hasTitle ? 'break-word' : 'normal')};

  &:hover {
    border: none;
    background-color: ${({ highlightColor }) => highlightColor};
    color: var(--ax-white);
  }

  @media (min-width: 67.5rem) {
    font-size: ${({ hasTitle }) => (hasTitle ? '1rem' : '2rem')};
    width: ${({ hasTitle }) => (hasTitle ? '250px' : '3.5rem')};
    height: ${({ hasTitle }) => (hasTitle ? 'auto' : '3.5rem')};
    min-height: ${({ hasTitle }) => (hasTitle ? '3.5rem' : '3.5rem')};
    padding: ${({ hasTitle }) => (hasTitle ? '1rem' : '0')};
  }
`;

export default Aside;
